import { queryOptions } from '@tanstack/react-query';

import API from '@api';

/**
 * Профиль пользователя (флаги подписок sms/email/promo и т.п.).
 * Без staleTime — всегда свежий, кэш дедуплицирует только параллельные
 * запросы; observable-зеркала подписок живут в UserStore.
 */
export const PEOPLE_PROFILE_QUERY_KEY = 'peopleProfile';

export const peopleProfileQueryOptions = () =>
  queryOptions({
    queryKey: [PEOPLE_PROFILE_QUERY_KEY],
    queryFn: () => API.getPeopleProfile()
  });
